export default __webpack_public_path__ + "static/media/fad-armrecording.5e85a43b.svg";